import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { NgxSpinnerService } from 'ngx-spinner';
import { Usuario } from './models/usuario';
import { DataService } from './_services/data.service';
import { TokenStorageService } from './_services/token-storage.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'matriculacion';
  public isLoggedIn;
  public usuarioLogueado?: Usuario;
  public showAdmin = false;
  showUser = false;
  public spinnerGeneral:boolean=true;
  constructor(private tokenStorageService: TokenStorageService, 
              private router: Router,
              private jwtHelper: JwtHelperService,
              private spinnerService:NgxSpinnerService,
              private dataService:DataService) {
    this.isLoggedIn = false;
  }

  ngOnInit(): void {
    let token = this.tokenStorageService.getToken();
    if (token != null && token != "") {
      if (!this.jwtHelper.isTokenExpired(token)) {
        this.isLoggedIn = true;
        this.usuarioLogueado = this.tokenStorageService.getUser();
      }else{
        this.logout();
      }
    }
    this.spinner();
    let roles:string[]=[];

    this.usuarioLogueado?.roles.forEach(element => {
      roles.push(element.denominacion);
    });
    this.tokenStorageService.saveRoles(roles);
    roles=this.tokenStorageService.getRoles();
  
    this.showAdmin=roles.includes("ADMINISTRADOR");
    this.showUser = roles.includes('AGENTE MATRICULADOR');
  }

  logout(): void {
    this.tokenStorageService.signOut();
    this.isLoggedIn = false;
    this.router.navigate(['login']);
  }

  spinner(){
    this.spinnerService.show();
    this.spinnerGeneral=false;
  }


}